// React
import React from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Components
import BLine from 'shop-components/components/MiniCart/styles/Line'
import FocalImage from 'ui/components/FocalImage'

// Shared
import NO_PRODUCT_IMAGE from '@assets/images/no-product-image.png'

const BundleItem = ({ product, photo, quantity }) => {
  if (!product) return null

  return (
    <BLine.BundleContentsItem>
      <BLine.Image>
        <FocalImage coordinates={photo?.coordinates ?? { x: 0, y: 0 }} url={photo?.url ?? NO_PRODUCT_IMAGE} />
      </BLine.Image>
      <BLine.BundleContentsQuantity>{quantity}x</BLine.BundleContentsQuantity>
      <div>{product.name}</div>
    </BLine.BundleContentsItem>
  )
}

BundleItem.displayName = 'BundleItem'

BundleItem.propTypes = {
  product: PropTypes.object,
  photo: PropTypes.object,
  quantity: PropTypes.number
}

const mapStateToProps = (state, props) => {
  const product = state.orm.products.getById(props.id)
  const photo = state.orm.photos.getById(product?.photo_id)

  return {
    product,
    photo
  }
}

export default reduxConnect(mapStateToProps)(BundleItem)
